<template>
    <div>
        <el-table ref="multipleTable" :data="agentList" tooltip-effect="dark" style="width: 100%;margin-top: 10px;" max-height="500">
            <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
            <el-table-column type="index" label="序号" :index="indexMethod"> </el-table-column>
            <el-table-column prop="name" label="名字" width="100" align="center"></el-table-column>
            <el-table-column prop="mobile" label="联系方式" width="120" align="center"></el-table-column>
            <!-- <el-table-column prop="job" label="职位" width="120" align="center"></el-table-column>
        <el-table-column prop="qq" label=QQ号码 width="100" align="center"></el-table-column>
        <el-table-column prop="email" label="email" width="120" align="center"></el-table-column> -->
            <el-table-column prop="province" label="省/市/区/州" width="100" align="center"></el-table-column>
            <el-table-column prop="city" label="市/区" width="100" align="center"></el-table-column>
            <el-table-column prop="area" label="县/区" width="120" align="center"></el-table-column>
            <el-table-column prop="address" label="地址" width="160" align="center"></el-table-column>
            <el-table-column label="操作" align="left">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import { getRequest, postRequest } from '@/utils/api';
export default {
    name: 'AgentList',
    data() {
        return {
            agentList: [],
            dustbinData: [],
        };
    },
    mounted() {
        this.getAllAgent();
    },
    methods: {
        getAllAgent() {
            getRequest('/agent/all')
                .then(resp => {
                    const { code, data } = resp.data;
                    if (code === 200) {
                        this.agentList = data;
                    }
                })
                .catch(resp => {
                    this.$message({ type: 'error', message: '数据加载失败!' });
                });
        },

        indexMethod(index) {
            return index + 1;
        },

        itemClick(row) {
            this.$router.push({ path: '/blogDetail', query: { aid: row.id } });
        },
        handleEdit(index, row) {
            this.$router.push({ path: '/addAgent', query: { status: 1, id: row.id } });
        },

        handleDelete(index, row) {
            this.dustbinData.push(row.id);
            this.deleteToDustBin(row.state);
        },
        deleteToDustBin(state) {
            let _this = this;
            this.$confirm('永久删除该文件, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
                .then(() => {
                    var url = '/agent/delete';
                    postRequest(url, {
                        id: _this.dustbinData,
                    }).then(resp => {
                        if (resp.status == 200) {
                            _this.$message({ type: 'success', message: '删除成功' });
                            _this.getAllAgent();
                            // location.reload();
                        } else {
                            _this.$message({ type: 'error', message: '删除失败!' });
                        }
                        _this.dustbinData = [];
                    });
                })
                .catch(() => {
                    _this.$message({ type: 'info', message: '已取消删除' });
                    _this.dustbinData = [];
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/agent/AgentList.vue